import { render, staticRenderFns } from "./c_set_up.vue?vue&type=template&id=0d2d59a5&scoped=true"
import script from "./c_set_up.vue?vue&type=script&lang=js"
export * from "./c_set_up.vue?vue&type=script&lang=js"
import style0 from "./c_set_up.vue?vue&type=style&index=0&id=0d2d59a5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2d59a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d2d59a5')) {
      api.createRecord('0d2d59a5', component.options)
    } else {
      api.reload('0d2d59a5', component.options)
    }
    module.hot.accept("./c_set_up.vue?vue&type=template&id=0d2d59a5&scoped=true", function () {
      api.rerender('0d2d59a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_set_up.vue"
export default component.exports